import React from "react";
import { AppLayOut } from "../../components/layout/AppLayOut";
import BackButton from "../../components/backbutton/BackButton";

const DealsAndSales = () => {
  return (
    <AppLayOut>
      <BackButton />
      <div>Deales and Sales</div>
    </AppLayOut>
  );
};

export default DealsAndSales;
